export const localization = {
  pt: {
    header: 'Consumo avançado de métricas',
    locale: 'pt-BR',
    monthPlaceholder: 'Período',
    title: 'Detalhamento das métricas',
    compiledInformation: {
      plan: 'Detalhamento das métricas',
      filter: 'Use o filtro para ver o total de {0} utilizadas em cada mês.',
      disclaimer:
        '*O fechamento de um mês estará disponível em até 5 dias úteis contados do último dia desse mesmo mês.',
      labels: {
        deus: 'DEUs',
        userConversations: 'User Conversations',
        prospectConversations: 'Adicional DEU MKT/Prospect',
        activeMessages: 'Mensagens Ativas',
        aiAdditional: 'Adicional IA',
      },
    },
    errorFetchingData:
      'Erro ao carregar os dados das métricas. Por favor, tente novamente mais tarde.',
    chatbotConsumption: {
      title: 'Contabilização por router/bot',
      about: 'Acompanhe o consumo do seu plano por router/bot',
      columnRouter: 'Router',
      columnDailyEngagedUsers: 'DEUs',
      columnUserConversations: 'User Conversations',
      columnProspectConversations: 'Adicional DEU MKT/Prospect',
      columnActiveMessages: 'Mensagens Ativas',
      columnAIAdditional: 'Adicional IA',
      buttonAllChatbots: 'Ver mais',
    },
    dailyConsumption: {
      title: 'Contabilização diária',
      about: 'Acompanhe o consumo do seu plano diariamente',
      columnDateReference: 'Data',
      columnDailyEngagedUsers: 'DEUs',
      columnUserConversations: 'User Conversations',
      columnProspectConversations: 'Adicional DEU MKT/Prospect',
      columnActiveMessages: 'Mensagens Ativas',
      columnAIAdditional: 'Adicional IA',
      buttonAllChatbots: 'Ver mais',
    },
  },

  en: {
    header: 'Advanced Metrics Consumption',
    locale: 'en-US',
    monthPlaceholder: 'Period',
    title: 'Metrics Breakdown',
    compiledInformation: {
      plan: 'Metrics Breakdown',
      filter: 'Use the filter to view the total number of {0} used each month.',
      disclaimer:
        '*The closing invoice of a month will be available within 5 business days from the last day of that month.',
      labels: {
        deus: 'DEUs',
        userConversations: 'User Conversations',
        prospectConversations: 'Additional MKT/Prospect DEU',
        activeMessages: 'Proactive messages',
        aiAdditional: 'AI Additional',
      },
    },
    errorFetchingData:
      'Error loading metrics data. Please try again later.',
    chatbotConsumption: {
      title: 'Consumption by router/bot',
      about: 'Track your plan consumption by router/bot',
      columnRouter: 'Router',
      columnDailyEngagedUsers: 'DEUs',
      columnUserConversations: 'User Conversations',
      columnProspectConversations: 'Additional MKT/Prospect DEU',
      columnActiveMessages: 'Proactive Messages',
      columnAIAdditional: 'AI Additional',
      buttonAllChatbots: 'See more',
    },
    dailyConsumption: {
      title: 'Daily count',
      about: 'Track your plan consumption daily',
      columnDateReference: 'Date',
      columnDailyEngagedUsers: 'DEUs',
      columnUserConversations: 'User Conversations',
      columnProspectConversations: 'Additional MKT/Prospect DEU',
      columnActiveMessages: 'Proactive Messages',
      columnAIAdditional: 'AI Additional',
      buttonAllChatbots: 'See more',
    },
  },

  es: {
    header: 'Consumo avanzado de métricas',
    locale: 'es-ES',
    monthPlaceholder: 'Período',
    title: 'Detalle de las Métricas',
    compiledInformation: {
      plan: 'Detalle de las Métricas',
      filter: 'Utilice el filtro para ver el número total de {0} utilizadas cada mes.',
      disclaimer:
        '*El cierre de un mes estará disponible dentro de los 5 días hábiles a partir del último dia de ese mes.',
      labels: {
        deus: 'DEUs',
        userConversations: 'User Conversations',
        prospectConversations: 'Mercado/Prospecto adicional de DEU',
        activeMessages: 'Mensajes proactivos',
        aiAdditional: 'Adicional IA',
      },
    },
    errorFetchingData:
      'Error al cargar los datos de las métricas. Por favor, inténtelo de nuevo más tarde.',
    chatbotConsumption: {
      title: 'Consumo por router/bot',
      about: 'Siga el consumo de su plan por router/bot',
      columnRouter: 'Router',
      columnDailyEngagedUsers: 'DEUs',
      columnUserConversations: 'User Conversations',
      columnProspectConversations: 'Mercado/Prospecto adicional de DEU',
      columnActiveMessages: 'Mensajes proactivos',
      columnAIAdditional: 'Adicional IA',
      buttonAllChatbots: 'Ver más',
    },
    dailyConsumption: {
      title: 'Contabilización diaria',
      about: 'Siga el consumo de su plan diariamente',
      columnDateReference: 'Fecha',
      columnDailyEngagedUsers: 'DEUs',
      columnUserConversations: 'User Conversations',
      columnProspectConversations: 'Mercado/Prospecto adicional de DEU',
      columnActiveMessages: 'Mensajes proactivos',
      columnAIAdditional: 'Adicional IA',
      buttonAllChatbots: 'Ver más',
    },
  },
};